define('plugin/multiple-booking/MultipleBookingPlugin',['require','__original__/MultipleBookingPlugin','lib/AppRouter','pwa/plugin/multiple-booking/controller/MultipleBookingController','pwa/plugin/multiple-booking/view/MultipleBookingCounterView'],function (require) {

    var MultipleBookingPlugin = require('__original__/MultipleBookingPlugin');
    var AppRouter = require('lib/AppRouter');
    var MultipleBookingController = require('pwa/plugin/multiple-booking/controller/MultipleBookingController');
    var MultipleBookingCounterView = require('pwa/plugin/multiple-booking/view/MultipleBookingCounterView');

    return MultipleBookingPlugin.extend({

        //TODO remove - multiple booking cart will be part of common cart same as on public site

        // initialize: function () {
        //     MultipleBookingPlugin.prototype.initialize.call(this);

        //     this.initRoutes();
        // },

        // initRoutes: function () {
        //     var controller = new MultipleBookingController({
        //         app: this.getOption('app'),
        //         clientModel: this.getOption('clientModel'),
        //         collection: this._bookingCollection,
        //     });

        //     this.listenTo(controller, 'checkout', this.saveMultipleBooking);

        //     var cartRouter = new AppRouter({
        //         appRoutes: {
        //             'client/cart(/)': 'cart',
        //         },
        //         controller: controller
        //     });
        // },

        // initModules: function (layout) {
        //     _.each(this._multipleBookingModulesRegions, function (selector, multipleRegion) {
        //         layout.addRegion(multipleRegion, selector);
        //     });

        //     var bookingsList = new MultipleBookingCounterView({
        //         collection: this._bookingCollection,
        //     });
        //     layout.multipleBookingCartModule.show(bookingsList);
        // },

    });

});
